import { render, staticRenderFns } from "./MatchedDocument.vue?vue&type=template&id=0ff2b4ab&"
import script from "./MatchedDocument.vue?vue&type=script&lang=ts&"
export * from "./MatchedDocument.vue?vue&type=script&lang=ts&"
import style0 from "./MatchedDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports